import React, {useState, useEffect} from 'react';
import clsx from 'clsx';

export default function TitleBar({productGroup, handleClose, ...props}) {
  return (
    <div className="text-pencil text-2xl p-2">
      {productGroup?.name}

      <div className="right-2 top-2 absolute">
        <a onClick={handleClose} className="cursor-pointer">
          <span className="fa fa-times text-2xl text-pencil"/>
        </a>
      </div>
    </div>
  );
}
